import React from "react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/5 mt-24">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-14 grid md:grid-cols-4 gap-10 text-sm">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-8 rounded-sm bg-gold flex items-center justify-center">
              <span className="font-display text-black text-lg font-bold">V</span>
            </div>
            <span className="font-display text-lg">Vision <span className="text-gold">Fashions</span></span>
          </div>
          <p className="text-slate-400 leading-relaxed">
            Bridging tangible real estate with institutional-grade crypto management for the modern investor.
          </p>
        </div>
        <div>
          <div className="text-slate-200 mb-3 font-semibold">Services</div>
          <ul className="space-y-2 text-slate-400">
            <li>Real Estate Portfolios</li>
            <li>Crypto Management</li>
            <li>Yield Strategies</li>
          </ul>
        </div>
        <div>
          <div className="text-slate-200 mb-3 font-semibold">Company</div>
          <ul className="space-y-2 text-slate-400">
            <li>About</li>
            <li>Contact</li>
            <li>Compliance</li>
          </ul>
        </div>
        <div>
          <div className="text-slate-200 mb-3 font-semibold">Contact</div>
          <ul className="space-y-2 text-slate-400">
            <li>hello@visionfashions.com</li>
            <li>+1 (555) 010-9930</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 py-6 flex items-center justify-between text-xs text-slate-500">
          <span>© {new Date().getFullYear()} Vision Fashions. All rights reserved.</span>
          <span className="font-mono-x">wealth · designed · secured</span>
        </div>
      </div>
    </footer>
  );
}
